import { render, staticRenderFns } from "./TalkTrendSaved.vue?vue&type=template&id=2bd8aeda&scoped=true"
import script from "./TalkTrendSaved.vue?vue&type=script&lang=js"
export * from "./TalkTrendSaved.vue?vue&type=script&lang=js"
import style0 from "./TalkTrendSaved.vue?vue&type=style&index=0&id=2bd8aeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8aeda",
  null
  
)

export default component.exports